"use strict";
exports.__esModule = true;
exports.NOT_APPROVED = void 0;
exports.NOT_APPROVED = {
    HEADER: "We can't offer you Flexible Rent at this time",
    BODY: 'Check your email for more information about this decision.',
    MESSAGE_SUPPORT: 'Learn more'
};
